export const norm = (s: unknown): string =>
  String(s ?? "").toLowerCase().replace(/đ/g, "dj").normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9 ]+/g, " ").replace(/\s+/g, " ").trim();

/** Extra folding so "djurdjevic" and "durdevic" both match đ. */
export const foldVariants = (s: string): string => { const n = norm(s); return n.includes("dj") ? `${n} ${n.replace(/dj/g, "d")}` : n; };

const TITLES = /\b(asis|demonstrator|prof|dr|doc|mr|ma|msc|phd|red|vanr|van|sc|dipl|ing|v|vs|ass|asist|asistent|visi|docent|redovni|vanredni|profesor|lektor|lektorica|emeritus|mag|oec|iur)\b/g;

export const personKey = (name: unknown): string => {
  const toks = norm(String(name ?? "").replace(/\(.*?\)/g, " ").split(",")[0]).replace(TITLES, " ").split(" ").filter((t) => t.length > 1 && !/\d/.test(t));
  return toks.length >= 2 ? toks.sort().join(" ") : "";
};

export const toMin = (t?: string | null): number | null => { const m = /^(\d{1,2})[:.](\d{2})/.exec(t || ""); return m ? +m[1] * 60 + +m[2] : null; };
export const fmt = (m: number): string => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
export const esc = (s: unknown): string => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);

export async function sha(s: string, n = 12): Promise<string> {
  const b = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(s));
  return [...new Uint8Array(b)].map((x) => x.toString(16).padStart(2, "0")).join("").slice(0, n);
}

/** Small sync hash (FNV-1a) for stable ids where async is inconvenient. */
export const fnv = (s: string): string => { let h = 0x811c9dc5; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); } return (h >>> 0).toString(36); };
